import React, { Component } from 'react';
import '../css/Global.min.css';
import PopUp from './PopUp';
import Biblioteca from '../Images/Biblioteca.jpg';
import Titulacion from '../Images/Titulacion.jpg';
import Modelo2 from '../Images/Modelo2.jpg';


class onlineMinis extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };

        this.mostrarProyecto = this.mostrarProyecto.bind(this);
        this.mostrarModelo = this.mostrarModelo.bind(this);
        this.mostrarTitulacion = this.mostrarTitulacion.bind(this);
        this.mostrarPopup = React.createRef();

    }

    mostrarProyecto() {
        this.mostrarPopup.current.mostrar(5);
    }

    mostrarModelo() {
        this.mostrarPopup.current.mostrar(6);
    }

    mostrarTitulacion() {
        this.mostrarPopup.current.mostrar(7);
    }

    render() {
        return (
            <div>
                <div className="CentrarH ListaTabla MarginAA">
                    <ul style={{ marginLeft: "65px" }}>

                        <li>
                            <div className="MiniHistoria">
                                <img src={Biblioteca} />
                                <div>
                                    <h3>Biblioteca Digital</h3>
                                    <p>Todos tus recursos siempre disponibles, acceso a m&aacute;s de 300,000 libros e investigaciones completas</p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div className="MiniHistoria">
                                <img src={Modelo2} />
                                <div>
                                    <h3>Modelo Educativo</h3>
                                    <p>El seguimiento a nuestros alumnos es importante, clases sabatinas en tiempo real, para solidificar tus aprendizajes y resolver dudas</p>
                                    <p>aplica sólo en modalidad en l&iacute;nea</p>
                                    <a onClick={this.mostrarModelo}>Ver video explicativo</a>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div className="MiniHistoria">
                                <img src={Titulacion} />
                                <div>
                                    <h3>Formas de Titulaci&oacute;n</h3>
                                    <p>Más de seis opciones de titulaci&oacute;n disponibles</p>
                                    <a onClick={this.mostrarTitulacion}>M&aacute;s informaci&oacute;n</a>
                                </div>
                            </div>
                        </li>


                    </ul>

                </div>

                <PopUp ref={this.mostrarPopup} />
            </div>
        );
    }
}

export default onlineMinis;


// WEBPACK FOOTER //
// ./src/components/onlineMinis.js